<template>
  <div class="password-reset-result container">
    <div class="my-5">
      <b-row align-h="center" align-v="center">
        <b-col cols="8" md="6" lg="6">
          <b-card no-body class="v2_box_teal">
            <b-card-header class="v2_box_teal_header">
              <div class="mb-0  v2_font_size_20 ">
                {{
                  success
                    ? 'Password reset successful.'
                    : 'Password reset failed.'
                }}
              </div>
            </b-card-header>
            <b-card-body>
              <p class="mt-2 v2_font_size_18  v2_color_black">{{ message }}</p>
            </b-card-body>
            <b-card-footer class="v2_bg_transparent">
              <p class="text-right mb-0">
                <b-btn variant="v2_primary" @click="onClose">
                  Close
                </b-btn>
              </p>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageForm',
  props: {
    success: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: 'Password reset successful.',
    },
  },
  methods: {
    onClose: function() {
      this.$router.push({ path: `/login` });
    },
  },
};
</script>

<style scoped/>
